import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import packageJson from '../../package.json';

@Injectable()
export class AnalyticsInterceptor implements HttpInterceptor {
  constructor(private route: ActivatedRoute,
              private router: Router) { }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // router.url carries the query string and fragment, and [^\/]+ happily swallows them because an
    // encoded query has no literal slash. That made /apps/forbidden?source=%2Fapps%2F... log as an app
    // named "forbidden?source=%2Fapps%2F...", splitting one route across a bucket per query string.
    const path = this.router.url.split('#')[0].split('?')[0];

    if (path.startsWith("/apps")) {

      const appMatch = path.match(/^\/apps\/([^\/]+)/);
      const app = appMatch ? appMatch[1] : null;

      const subMatch = path.match(/^\/apps\/[^\/]+(\/.*)?$/);
      const appSub = subMatch?.[1] || null;
      if (app) {
        const clonedRequest = request.clone({
          setHeaders: {
            'Analytics-AppRoute': app,
            'Analytics-AppSubRoute': appSub ?? '',
            'Analytics-AppVersion': packageJson.version
          }
        });
        return next.handle(clonedRequest);
      }
      
    }
    return next.handle(request);
  }
}
